import React from "react";

// Central brand asset for SchoolLane. If the logo file ever changes, replace
// only /public/brand/schoollane-logo.png — every component below refreshes
// automatically. Brand-mark (book-in-cart only) lives at schoollane-mark.png
// and is used for favicon + PWA + very-compact mobile.

export const BRAND_COLORS = {
  school: "#003870",   // sampled from the wordmark "School" (blue)
  lane:   "#D0A008",   // sampled from the wordmark "Lane"   (gold)
};

/** Full SchoolLane logo — book-in-cart + wordmark + tagline. */
export function Logo({ height = 40, className = "", mark = false }) {
  const src = mark
    ? "/brand/schoollane-mark.png"      // book-in-cart only
    : "/brand/schoollane-logo.png";     // full logo
  return (
    <img
      src={src}
      alt="SchoolLane"
      height={height}
      style={{ height, width: "auto" }}
      className={"select-none " + className}
      loading="eager"
      decoding="async"
    />
  );
}

export default Logo;
